/**
 * @generated SignedSource<<62f2fa8116a9031ad7170426b9ca128d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConnectAuthAccountUserInboxPayload",
    "kind": "LinkedField",
    "name": "connectAuthUserInbox",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ResponseType",
        "kind": "LinkedField",
        "name": "connectionResponse",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userInboxId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConnectAuthUserInboxMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConnectAuthUserInboxMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d4c359583d1bf8f1faf44d6ce309d3b3",
    "id": null,
    "metadata": {},
    "name": "ConnectAuthUserInboxMutation",
    "operationKind": "mutation",
    "text": "mutation ConnectAuthUserInboxMutation(\n  $input: ConnectAuthAccountUserInboxInput!\n) {\n  connectAuthUserInbox(input: $input) {\n    connectionResponse {\n      success\n      userInboxId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "62e78dd633d57cb66abf64a5648eee3d";

module.exports = node;
